/** 账号输入类型：11 位纯数字为手机；同时含 @ 与 . 为邮箱；否则为用户名 */
export type AccountKind = 'mobile' | 'email' | 'username';

export function detectAccountKind(value: string): AccountKind {
  const trimmed = value.trim();
  if (/^\d{11}$/.test(trimmed)) {
    return 'mobile';
  }
  if (trimmed.includes('@') && trimmed.includes('.')) {
    return 'email';
  }
  return 'username';
}

export function validateAccountInput(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return '账号不能为空';
  }
  const kind = detectAccountKind(trimmed);
  if (kind === 'mobile' && !/^1[3-9]\d{9}$/.test(trimmed)) {
    return '手机号格式不正确';
  }
  return null;
}
